import React, { useState } from 'react'

import { Button } from 'primereact/button'

import { SectionResult } from '../upload/sections'

export const InfoAttachmentDialog: React.FC = () => {
  const [visible, setVisible] = useState(false)

  return (
    <>
      <Button
        icon={'pi pi-info-circle'}
        className="p-button-rounded p-button-text"
        onClick={() => setVisible(true)}
      />

      {visible && (
        <SectionResult
          disabled={false}
          setVisible={setVisible}
          visible={visible}
        />
      )}
    </>
  )
}
